module.exports = __webpack_public_path__ + "img/female_2.2adc4a31.png";